import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IDatabaseResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabaseResponseInstance'

export function mapDatabaseResponseInstance(database: IToJson<IDatabaseResponseInstance>): IDatabaseResponseInstance {
  return database
}
